/** The AI models page's reads and writes (SA-1087 §12). Every write invalidates the one key. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { clearAiModel, listAiModels, listProviderModels, saveAiModel, testAiModel } from '@/services/aiModels'
import type { AiModelWrite } from '@/types/aiModels'

export const aiModelsKey = ['admin', 'ai-models'] as const

export function useAiModels() {
  return useQuery({ queryKey: aiModelsKey, queryFn: listAiModels, retry: false })
}

export function useSaveAiModel() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: AiModelWrite }) => saveAiModel(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: aiModelsKey }),
  })
}

export function useClearAiModel() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => clearAiModel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: aiModelsKey }),
  })
}

export function useTestAiModel() {
  return useMutation({ mutationFn: ({ id, body }: { id: string; body: AiModelWrite }) => testAiModel(id, body) })
}

/** The provider's models for the dialog's row as typed (SA-1103): reads nothing back into the list. */
export function useProviderModels() {
  return useMutation({ mutationFn: ({ id, body }: { id: string; body: AiModelWrite }) => listProviderModels(id, body) })
}
